export enum RideSoftValidationErrorType {
  PriceRate = "PriceRate",
  Duration = "Duration",
  PassengerDuration = "PassengerDuration",
  PassengerType = "PassengerType",
  Stations = "Stations",
  GeoProdMaxShiftGapDeparture = "GeoProdMaxShiftGapDeparture",
  GeoProdMaxShiftGapArrival = "GeoProdMaxShiftGapArrival",
  RideCancel = "RideCancel",
  PriceRateChangedRideCancel = "PriceRateChangedRideCancel",
  PriceRateChanged = "PriceRateChanged",
  RideSwitchToDraft = "RideSwitchToDraft",
  SupplierFreezeTimeToCreateRide = "SupplierFreezeTimeToCreateRide",
  SupplierFreezeTimeToChangeRide = "SupplierFreezeTimeToChangeRide",
  SupplierFreezeTimeToCancelRide = "SupplierFreezeTimeToCancelRide",
  RideAndPassengerDatesAreNotWithinAcceptableRange = "RideAndPassengerDatesAreNotWithinAcceptableRange",
  ShiftTimeAlignmentPickupTooEarly = "ShiftTimeAlignmentPickupTooEarly",
  ShiftTimeAlignmentPickupTooLate = "ShiftTimeAlignmentPickupTooLate",
  ShiftTimeAlignmentDropoffTooEarly = "ShiftTimeAlignmentDropoffTooEarly",
  ShiftTimeAlignmentDropoffTooLate = "ShiftTimeAlignmentDropoffTooLate",
  HubUpdate = "HubUpdate",
  HubDelete = "HubDelete",
  DoneRidePriceRecalculate = "DoneRidePriceRecalculate",
  FlexRideWillBeMergedToDynamic = "FlexRideWillBeMergedToDynamic",
  FlexRideWillBeMergedToDynamicStationMismatch = "FlexRideWillBeMergedToDynamicStationMismatch",
  FlexRideWillBeMergedToDynamicTimeMismatch = "FlexRideWillBeMergedToDynamicTimeMismatch",
}

export const RideGeoProdMaxShiftGapErrorTypes = new Set([
  RideSoftValidationErrorType.GeoProdMaxShiftGapDeparture,
  RideSoftValidationErrorType.GeoProdMaxShiftGapArrival,
]);

export const RideSoftValidationFreezeTimeTypes = new Set([
  RideSoftValidationErrorType.SupplierFreezeTimeToCreateRide,
  RideSoftValidationErrorType.SupplierFreezeTimeToChangeRide,
  RideSoftValidationErrorType.SupplierFreezeTimeToCancelRide,
]);

export const RideShiftTimeAlignmentErrorTypes = new Set([
  RideSoftValidationErrorType.ShiftTimeAlignmentPickupTooEarly,
  RideSoftValidationErrorType.ShiftTimeAlignmentPickupTooLate,
  RideSoftValidationErrorType.ShiftTimeAlignmentDropoffTooEarly,
  RideSoftValidationErrorType.ShiftTimeAlignmentDropoffTooLate,
]);

export const RideSoftValidationHubErrorTypes = new Set([
  RideSoftValidationErrorType.HubUpdate,
  RideSoftValidationErrorType.HubDelete,
]);
